import { Button, Grid, IconButton, Typography } from '@mui/material';
import { ToggleRedWhite } from '../../../../assets/images/UI-dashboard';
import OutputFilterDropdown from '../../../../components/OutputFilters/OutputFilterDropdown';
import { ResultFiltersContainer } from './ResultFilters.Styled';
import {
  fetchOutputFilters,
  resetOutputFilters,
  setToggle,
  setViewBy,
} from '../../../../features/outputFilters/outputfilterSlice';
import { useAppDispatch, useAppSelector } from '../../../../state/hooks';
import { getOutputOverview } from '../../../../features/outputOverview/outputOverviewSlice';
import { RootState } from '../../../../state/store';
import { hideLoader, showLoader } from '../../../../features/ui/loaderSlice';
import { fetchOutputBrands } from '../../../../features/outputSegmentDeepDive/outputBrandsSlice';
import { SCENARIO_OUTPUT_DATA } from '../../../../utils/dataConstants';
import { SelectMapperKeys, ViewByMapperKeysForDeepdive } from '../../../../types/common';
import { fetchSegmentDeepDive } from '../../../../features/outputSegmentDeepDive/outputSegmentDeepDiveSlice';
import { RefreshOutlined } from '@mui/icons-material';

export const ResultFilters = () => {
  const dispatch = useAppDispatch();

  const { scenarios, selectedScenarios, isDeepdiveVisible } = useAppSelector(
    (state: RootState) => state.outputSegmentDeepDive,
  );
  const { selectedToggle, selectedViewBy, enabledKeys } = useAppSelector((state: RootState) => state.outputFilters);
  const { outputBrands, selectedOutputBrands } = useAppSelector((state: RootState) => state.outputBrands);
  const handleToggleChange = async () => {
    await dispatch(showLoader());
    await dispatch(setToggle(selectedToggle === 'All Segment' ? 'Intervened Segment' : 'All Segment'));
    await dispatch(getOutputOverview({ scenarioNames: scenarios, option: 'toggle' }));
    await dispatch(hideLoader());
    if (isDeepdiveVisible) {
      await updateDeepDiveData();
    }
  };

  const handleViewByChange = async (viewBy: string) => {
    await dispatch(showLoader());
    await dispatch(setViewBy(viewBy));
    await dispatch(getOutputOverview({ scenarioNames: scenarios, option: 'toggle' }));
    await dispatch(hideLoader());
    if (isDeepdiveVisible) {
      await updateDeepDiveData();
    }
  };

  const updateDeepDiveData = async () => {
    await dispatch(showLoader());
    const outputBrandPayload = {
      scenario_name: scenarios,
      bottler: enabledKeys.bottler,
      state: enabledKeys.state,
    };
    const brandData = outputBrands;
    let selectedBrands = selectedOutputBrands;
    if (brandData.length === 0) {
      const response = await dispatch(fetchOutputBrands(outputBrandPayload));
      selectedBrands = response.payload;
    }

    const segmentPayload = {
      scenario_1: selectedScenarios.base,
      scenario_2: selectedScenarios.child,
      brand: selectedBrands,
      bottler: enabledKeys.bottler,
      state: enabledKeys.state,
      select: SCENARIO_OUTPUT_DATA.SELECT_MAPPER[selectedToggle as SelectMapperKeys],
      view_by: SCENARIO_OUTPUT_DATA.VIEW_BY_MAPPER_DEEPDIVE[selectedViewBy as ViewByMapperKeysForDeepdive],
    };
    await dispatch(fetchSegmentDeepDive(segmentPayload));
    await dispatch(hideLoader());
  };

  const onReset = async () => {
    await dispatch(showLoader());
    await dispatch(resetOutputFilters());
    await dispatch(
      fetchOutputFilters({
        scenario_names: scenarios,
        state: [],
        bottler: [],
      }),
    );
    await dispatch(getOutputOverview({ scenarioNames: scenarios, option: 'toggle' }));
    await dispatch(hideLoader());
    if (isDeepdiveVisible) {
      await updateDeepDiveData();
    }
  };

  return (
    <Grid
      style={{
        margin: '1% auto',
        padding: '1%',
        marginTop: '82px',
        backgroundColor: 'white',
        borderRadius: '5px',
        maxWidth: '1265.01px',
        boxShadow: '0 3px .625pc 0 rgb(0 0 0 / 6%) !important',
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '39.83px',
          lineHeight: '48.55px',
          marginLeft: '10px',
        }}
      >
        Scenario Result
      </Typography>
      <ResultFiltersContainer>
        <Grid style={{ marginTop: '10px', display: 'grid', gridTemplateColumns: '30% 40% 30%' }}>
          <Grid style={{ display: 'flex', marginLeft: '5px' }}>
            <Grid>
              <OutputFilterDropdown filterKey="state" label="States:" />
            </Grid>
            <Grid style={{ marginLeft: '8%' }}>
              <OutputFilterDropdown filterKey="bottler" label="Bottlers:" />
            </Grid>
            <Grid>
              <IconButton style={{ padding: 0 }} onClick={onReset}>
                <RefreshOutlined
                  style={{
                    color: 'red',
                    fontSize: '15px',
                    padding: '0px',
                    marginLeft: '5px',
                    cursor: 'pointer',
                  }}
                ></RefreshOutlined>
              </IconButton>
            </Grid>
          </Grid>

          <Grid
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              whiteSpace: 'nowrap',
              marginLeft: '20%',
            }}
            item
          >
            <Typography
              style={{
                fontWeight: 600,
                fontSize: '10.89px',
                lineHeight: '13.35px',
              }}
            >
              Select:
            </Typography>

            <Typography
              style={{
                fontWeight: 600,
                fontSize: '10.89px',
                marginLeft: '5px',
                color: '#333333',
                opacity: selectedToggle === 'All Segment' ? '100%' : '40%',
              }}
            >
              All Segment
            </Typography>

            <img
              style={{
                cursor: 'pointer',
                marginLeft: '5px',
                transform: selectedToggle === 'Intervened Segment' ? 'rotate(180deg)' : 'rotate(0deg)',
              }}
              src={ToggleRedWhite}
              alt="toggle"
              onClick={handleToggleChange}
            />

            <Typography
              style={{
                fontWeight: 600,
                fontSize: '10.89px',
                marginLeft: '5px',
                color: '#333333',
                opacity: selectedToggle === 'Intervened Segment' ? '100%' : '40%',
              }}
            >
              Intervened Segment
            </Typography>
          </Grid>

          <Grid
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginLeft: '6%',
            }}
            item
            xs={12}
            sm={6}
            md={3}
          >
            <Typography
              style={{
                fontWeight: 600,
                fontSize: '10.89px',
                lineHeight: '13.35px',
                whiteSpace: 'nowrap',
              }}
            >
              View By:
            </Typography>

            <Button
              style={{
                padding: '2px 10px',
                borderRadius: '36.31px',
                marginLeft: '5px',
                border: selectedViewBy === 'Absolute' ? '1px solid #DF2020 ' : '1px solid #E3E6EB',
                backgroundColor: selectedViewBy === 'Absolute' ? '#DF2020' : '#FFFFFF',
                color: selectedViewBy === 'Absolute' ? '#FFFFFF' : '#000000',
              }}
              onClick={() => handleViewByChange('Absolute')}
            >
              Absolute
            </Button>

            <Button
              style={{
                padding: '2px 10px',
                borderRadius: '36.31px',
                marginLeft: '5px',
                border: selectedViewBy === 'Incremental' ? '1px solid #DF2020 ' : '1px solid #E3E6EB',
                backgroundColor: selectedViewBy === 'Incremental' ? '#DF2020' : '#FFFFFF',
                color: selectedViewBy === 'Incremental' ? '#FFFFFF' : '#000000',
              }}
              onClick={() => handleViewByChange('Incremental')}
            >
              Incremental
            </Button>

            <Button
              style={{
                padding: '2px 10px',
                borderRadius: '36.31px',
                marginLeft: '5px',
                border: selectedViewBy === 'Percent' ? '1px solid #DF2020 ' : '1px solid #E3E6EB',
                backgroundColor: selectedViewBy === 'Percent' ? '#DF2020' : '#FFFFFF',
                color: selectedViewBy === 'Percent' ? '#FFFFFF' : '#000000',
              }}
              onClick={() => handleViewByChange('Percent')}
            >
              Percent
            </Button>
          </Grid>
        </Grid>
      </ResultFiltersContainer>
    </Grid>
  );
};
